<template>
    <v-container>
        <v-row>
            <v-col class="d-flex justify-center">
                <v-img src="@/assets/checkmark-circle-grey-green.png" rel="preload" max-width="25%" alt="Success!">
                    <template v-slot:placeholder>
                        <v-row class="fill-height ma-0"
                               align="center"
                               justify="center">
                            <v-skeleton-loader type="image" max-height="200"></v-skeleton-loader>
                        </v-row>
                    </template>
                </v-img>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="text-center">
                <strong style="display: block; font-size: 18px;">Thank you for signing in to {{ currentModel.settings.clientName }}!</strong>
            </v-col>
        </v-row>
        <v-row v-if="onlineSuccessMessage">
            <v-col class="text-center" style="font-size: 18px;">
                <p>
                    {{ onlineSuccessMessage }}
                </p>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="text-center">
                <v-btn large color="secondary" @click="backToLobbyInternal" raised style="font-size: 18px; font-weight: 700;">Back to home</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ContextualMixin from '../mixins/contextualMixin'
    var onlineSuccessTimeout;
    export default {
        name: 'OnlineSuccess',
        mixins: [ContextualMixin],
        computed: {
            confirmationMessage() {
                if (!this.currentModel || !this.currentModel.settings.localizedContent)
                    return null;
                return this.currentModel.settings.localizedContent['walkin_confirmation_message'] || null;
            },
            onlineSuccessMessage() {
                if (!this.currentModel || !this.currentModel.settings.localizedContent)
                    return null;
                return this.currentModel.settings.localizedContent['reservation_online_success_confirmation'] || null;
            }
        },
        mounted() {
            this.$store.state.currentStep = 0;
            if (this.currentModel.settings.redirectToHomePage) {
                onlineSuccessTimeout = setTimeout(() => {
                    this.backToLobby();
                }, 15000);
            }
        },
        methods: {
            backToLobbyInternal() {
                clearTimeout(onlineSuccessTimeout);
                this.backToLobby();
            }
        }
    }
</script>